import { Pipe, PipeTransform } from '@angular/core';
import { PaymentStatus, PaymentStatusTranslations } from 'src/app/core/enums/payment-status.enum';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({
    name: 'paymentStatus',
    pure: false
})
export class PaymentStatusPipe implements PipeTransform {

    constructor(private localizationService: LocalizationService) { }

    transform(value: PaymentStatus | string): string {
        if (!value) {
            return '';
        }

        const lang = this.localizationService.getCachedLanguage();
        return lang === 'ar' ? PaymentStatusTranslations[value as PaymentStatus] || value : value;
    }
}
